import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { openListSettings } from 'app/components/lists/ListSettingsDialog'
import { useSettings } from 'app/hooks/useSettings'
import { useListStore } from 'app/stores/StoreContext'
import type { ListSettingsTarget } from 'app/types/list-settings'
import type { NavListsSetting } from 'app/types/navigation'
import { useHandleSearchParams, useWorkspace } from 'app/utils'
import { requestColumnEditor } from 'lib/columnEditorRequest'
import { afterListDeletedPath } from 'lib/lists'
import { navListsSettingKey } from 'lib/navLists'

/** Opens the Settings view for the list on this page. */
export function useOpenListSettings(target: ListSettingsTarget, onChanged: () => void): () => void {
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const handleSearchParams = useHandleSearchParams()
  const listStore = useListStore()
  const workspace = useWorkspace()
  const [navLists] = useSettings<NavListsSetting>(navListsSettingKey(workspace?.id))
  const workspaceQuery = searchParams.has(`wId`) ? `?wId=${searchParams.get(`wId`)}` : ``

  return () =>
    openListSettings({
      target,
      onChanged,
      // Only a practice list has a Delete row, so only it can land here.
      onDeleted: () => {
        if (target.source === `practice`)
          navigate(afterListDeletedPath(target.list.id, listStore.hits, navLists?.order ?? [], workspaceQuery))
      },
      onEditColumns: (backToSettings) => {
        handleSearchParams({ view: `table` })
        requestColumnEditor(location.pathname, { back: { to: `Settings`, onBack: backToSettings } })
      },
    })
}
